import type { ApplicationFilterOptionRestriction } from "./IApplicationFilterComponent";

export function resolveOptionRestriction(
    optionRestriction?: ApplicationFilterOptionRestriction,
    restrictedValues?: unknown[],
): ApplicationFilterOptionRestriction | undefined {
    if (optionRestriction) return optionRestriction;
    if (!restrictedValues?.length) return undefined;

    return {
        type: "allowOnly",
        values: restrictedValues,
    };
}

export function buildRestrictionValueSet(
    optionRestriction?: ApplicationFilterOptionRestriction,
): Set<string> {
    return new Set(
        (optionRestriction?.values ?? []).map((value) => `${value}`),
    );
}

export function isValueAllowedByOptionRestriction(
    value: unknown,
    optionRestriction?: ApplicationFilterOptionRestriction,
    restrictedValues?: ReadonlySet<string>,
): boolean {
    if (!optionRestriction || (optionRestriction.values?.length ?? 0) === 0) {
        return true;
    }

    const values = restrictedValues ?? buildRestrictionValueSet(optionRestriction);
    const normalizedValue = `${value}`;

    if (optionRestriction.type === "allowOnly") {
        return values.has(normalizedValue);
    }

    return !values.has(normalizedValue);
}
